import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { some, filter, includes } from 'lodash';
import { Event, EventValue } from '../../../../models/calendar';
import {
  getCalendarState,
  MarketDrawerRootReducerState
} from '../../../../state/reducer';

export const POTENTIAL_COLUMNS: string[] = [
  'previous',
  'consensus',
  'actual',
  'revised'
];

@Component({
  selector: 'muni-gameday-value-table',
  templateUrl: './value-table.template.html',
  styleUrls: ['./value-table.styles.scss']
})
export class ValueTableComponent {
  @Input()
  event: Event;
  public fullscreen: Observable<boolean>;
  public readonly columns: Observable<string[]> = this.store.pipe(
    map(getCalendarState),
    map(s => {
      const availableColumns = this.getColumns();

      if (!s.fullscreen) {
        if (includes(availableColumns, 'actual')) {
          return ['actual'];
        } else if (includes(availableColumns, 'consensus')) {
          return ['consensus'];
        } else if (includes(availableColumns, 'previous')) {
          return ['previous'];
        } else {
          return [availableColumns[0]];
        }
      } else {
        return availableColumns;
      }
    })
  );

  constructor(private store: Store<MarketDrawerRootReducerState>) {}

  public getColumns(): string[] {
    return filter(POTENTIAL_COLUMNS, potentialColumn => {
      return some(this.event.values, potentialColumn);
    });
  }

  public formatValue(value: EventValue, key: string): string {
    return `${value.prefix || ''}${value[key] || ''}${value.suffix || ''}`;
  }
}
